// extracted by mini-css-extract-plugin
module.exports = {"btn":"style_btn__KSslk","customLoader":"style_customLoader__3fOTx"};